export enum VentureSectorModalModes {
  VIEW = "view",
  CREATE = "create",
  EDIT = "edit",
}
